module.exports = __webpack_public_path__ + "static/pinktiny-f80345935099745ff97190bcfd23678e.jpeg";